import React from 'react';
import { SparklesIcon, UserIcon, ArrowDownIcon, CheckIcon } from 'lucide-react';
import { demoOutput, demoPromptExcerpt, reviewSteps } from '../../data/samplePrompts';
export function PromptDemo() {
  return <div className="mx-auto mt-14 max-w-3xl" data-id="element-233" data-mp="3glwd8ntjdru3">
      <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-234" data-mp="3gklamrbtuq4k">See it in action</p>
      <h3 className="mt-2 font-display text-2xl font-bold uppercase text-fog sm:text-3xl" data-id="element-235" data-mp="3blryp3c6v76i">
        From a basic request to a structured security report
      </h3>
      <p className="mt-2 text-sm text-fog/60" data-id="element-236" data-mp="2j0i7lspy9kpb">
        An illustrative example of the workflow — not a claim that the output is automatically accurate or suitable for every
        security company.
      </p>

      <div className="mt-5 overflow-hidden rounded-2xl border border-line bg-ink-2" data-id="element-237" data-mp="2svsbyn3tm469">
        <div className="flex items-center gap-1.5 border-b border-line bg-ink-3 px-4 py-2.5" aria-hidden="true" data-id="element-238" data-mp="256hi7pkw1a1m">
          <span className="h-2.5 w-2.5 rounded-full bg-teal" data-id="element-239" data-mp="208677biuwtht" />
          <span className="h-2.5 w-2.5 rounded-full bg-gold" data-id="element-240" data-mp="1scdpioc6m96h" />
          <span className="h-2.5 w-2.5 rounded-full bg-fog/20" data-id="element-241" data-mp="1sa1bundgikz8" />
          <span className="ml-3 text-[11px] font-semibold text-fog/50" data-id="element-242" data-mp="1wc4npd41frl1">AI assistant</span>
        </div>

        <div className="space-y-5 p-4 sm:p-6" data-id="element-243" data-mp="214pfya7apwmg">
          <div data-id="element-244" data-mp="262zemus8bfct">
            <p className="text-xs font-bold uppercase tracking-wider text-teal" data-id="element-245" data-mp="263ikhd4ludah">1 · You provide the instructions</p>
            <div className="mt-2 flex gap-3" data-id="element-246" data-mp="19e1esy5mgr8s">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ink-3 text-gold" data-id="element-247" data-mp="19fcm37ya0h4n">
                <UserIcon className="h-4 w-4" aria-hidden="true" data-id="element-248" data-mp="1idy0cqwpt9zm" />
              </span>
              <div className="rounded-2xl rounded-tl-sm border border-line bg-ink px-4 py-3" data-id="element-249" data-mp="1ncremljtt50u">
                <p className="text-sm leading-relaxed text-fog/80" data-id="element-250" data-mp="1naeq1pjkbwet">{demoPromptExcerpt}</p>
                <p className="mt-2 text-[11px] font-semibold text-fog/45" data-id="element-251" data-mp="2tuxttpustuv8">Example prompt · Security Incident Report</p>
              </div>
            </div>
          </div>

          <ArrowDownIcon className="mx-auto h-5 w-5 text-fog/30" aria-hidden="true" data-id="element-252" data-mp="2927mp4rwfi6h" />

          <div data-id="element-253" data-mp="243o2b8syeeg8">
            <p className="text-xs font-bold uppercase tracking-wider text-gold" data-id="element-254" data-mp="244622fetrasw">2 · The AI generates a structured draft</p>
            <div className="mt-2 flex gap-3" data-id="element-255" data-mp="2izm354dto6ys">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-teal text-ink" data-id="element-256" data-mp="2e2ltkjhrkm2x">
                <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-257" data-mp="1qe2o0bq3mnej" />
              </span>
              <div className="min-w-0 flex-1 rounded-2xl rounded-tl-sm border border-teal/25 bg-ink px-4 py-3" data-id="element-258" data-mp="1lf986cncakb7">
                <p className="border-b border-line pb-2 font-display text-sm font-bold uppercase tracking-wide text-fog" data-id="element-259" data-mp="203vwv4yuwof3">{demoOutput.title}</p>
                <ol className="mt-3 space-y-3" data-id="element-260" data-mp="17mtei2gbvymy">
                  {demoOutput.sections.map((s, i) => <li key={s.heading} data-id="element-261" data-mp="12nyl66kqirol" data-mpi={i}>
                      <p className="text-sm font-bold text-fog" data-id="element-262" data-mp="12mx85wk5rv48">
                        {i + 1}. {s.heading}
                      </p>
                      {s.lines.map(l => <p key={l} className="mt-0.5 pl-4 text-sm text-fog/60" data-id="element-263" data-mp="3j21yegyufsfq">
                          · {l}
                        </p>)}
                    </li>)}
                </ol>
              </div>
            </div>
          </div>

          <ArrowDownIcon className="mx-auto h-5 w-5 text-fog/30" aria-hidden="true" data-id="element-264" data-mp="wf918vr8fy4" />

          <div data-id="element-265" data-mp="5v8lqz37w2x8">
            <p className="text-xs font-bold uppercase tracking-wider text-teal" data-id="element-266" data-mp="5vs5mlcfh1dw">3 · You review before using it</p>
            <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-267" data-mp="3o1myiupr26u1">
              {reviewSteps.map(step => <li key={step} className="flex items-start gap-2 text-sm text-fog/80" data-id="element-268" data-mp="3s1fazii9kx4o">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-269" data-mp="2clgj7hsyfdql" />
                  {step}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="border-t border-gold/30 bg-ink-3 px-5 py-3 text-center" data-id="element-270" data-mp="2wvhlyi4xqy8i">
          <p className="text-sm font-semibold text-fog/80" data-id="element-271" data-mp="2s3g48gp00fb3">
            You remain responsible for the accuracy and approval of the final report.
          </p>
        </div>
      </div>
    </div>;
}